import * as React from 'react';
import { ModuleNamesList } from '../../../core/lists/ModuleNamesList';
import TranslationService from '../../../core/services/TranslationService';

export const DirectPaymentLargerAmountNotice = () => {
    return <>{TranslationService.translateModule('DirectPaymentLargerAmountNotice', ModuleNamesList.DirectPayment)}</>
}